module.exports = __webpack_public_path__ + "media/images/countrysquared/cg-9ba53d88b78f16d0e1bc41694ea378e9.svg";